/* eslint-disable perfectionist/sort-objects */
export const inventoryListColumns = {
	actionMenu: 28,
	checkbox: 24,
	modelName: 280,
	inventoryStatus: 200,
	salesStatus: 200,
	vehicleType: 70,
	mileageFirstRegistrationDate: 120,
	mileageModelYear: 100,
	price: 160,
	location: 150,
}
